import { gql } from '@apollo/client';

export const emergencyContactsName = 'EmergencyContacts';
export const emergencyContacts = gql`
	fragment ${emergencyContactsName} on Member {
		emergencyContacts {
			firstName
      lastName
      relationship
      phoneNumber
      email
		}
	}
`;
